import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { share } from 'rxjs/operators';

export interface ILocalStorageData {
  usage: number,
  quota: number,
  percentUsed: number
}

@Injectable({
  providedIn: 'root'
})
export class LocalstorageManagerService {
  // lets say we could use 90% of storage for prevent slow down system
  readonly storageGapPercentage = 90;
  public storageCapacityAPI = false;
  public limitReached$: Observable<boolean> = new Observable();

  constructor() {

    this.storageCapacityAPI = this.storageApiAccessable();
    // console.log(this.storageCapacityAPI, 'storageCapacityAPI');
    if (this.storageCapacityAPI) {
      this.limitReached$ = from(this.ifLimitStorageReached()).pipe(share())
      // this.ifLimitStorageReached().then(r => {
      //   this.limitReached = r;
      //   // console.log(this.limitReached, 'limitReached');
      // });
    }
  }

  private storageApiAccessable(): boolean {
    return !!(navigator && navigator.storage && navigator.storage.estimate);
  }

  private async ifLimitStorageReached(): Promise<boolean> {
    const percentUsed = await this.getEstimatedPercentage();
    if (percentUsed >= this.storageGapPercentage) {
      return true;
    }
    return false;
  }

  public async estimateStorageUsage(): Promise<ILocalStorageData | null> {
    if (this.storageCapacityAPI) {
      const storageEstimate = await navigator.storage.estimate();
      if (storageEstimate.quota && storageEstimate.usage !== undefined) {
        return {
          usage: storageEstimate.usage / Math.pow(1000, 2),
          quota: storageEstimate.quota / Math.pow(1000, 2),
          percentUsed: storageEstimate.usage / storageEstimate.quota * 100
        };
      }
    }
    return null;
  }

  public async getEstimatedPercentage(): Promise<number> {
    const storageUsed = await this.estimateStorageUsage();
    if (storageUsed) {
      return storageUsed.percentUsed;
    }
    return 0;
  }

  public async isFileLargerThanStorageQuota(file: File): Promise<boolean> {
    const storageEstimate = await navigator.storage.estimate();
    if (storageEstimate && storageEstimate.quota && storageEstimate.quota > file.size) {
      return false;
    } else {
      return true;
    }
  }
}
